import React from 'react';
import { Palette, History, MapPin, Package, FileText, Route } from 'lucide-react';
import { features } from '../../data/mock';

const iconMap = {
  Palette,
  History,
  MapPin,
  Package,
  FileText,
  Route
};

const FeaturesGrid = () => {
  return (
    <section id="features" className="py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#000000]" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-[#00FFD1]/5 rounded-full blur-[150px]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="max-w-3xl mb-20">
          <span className="text-[#00FFD1] text-sm font-medium tracking-wider uppercase">Feature Spotlight</span>
          <h2 className="text-4xl md:text-5xl font-semibold text-white mt-4 leading-tight">
            Everything You Need.
            <span className="block text-white/50">Nothing You Don&apos;t.</span>
          </h2>
          <p className="text-white/60 text-xl mt-6 leading-relaxed">
            Built by distributors, for distributors. Every feature solves a real problem from the field.
          </p>
        </div>
        
        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="group relative bg-[#121212] border border-white/10 p-8 transition-all duration-400 hover:border-[#00FFD1]/40"
              >
                {/* Hover Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#00FFD1]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                
                <div className="relative">
                  {/* Icon */}
                  <div className="w-14 h-14 bg-[#00FFD1]/10 flex items-center justify-center mb-6 transition-all duration-400 group-hover:bg-[#00FFD1]/20">
                    {Icon && <Icon className="w-7 h-7 text-[#00FFD1]" />}
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-semibold text-white mb-3">{feature.title}</h3>
                  <p className="text-white/60 leading-relaxed">{feature.description}</p>
                  
                  {/* Feature Number */}
                  <div className="absolute top-0 right-0 text-6xl font-bold text-white/5 group-hover:text-[#00FFD1]/10 transition-colors duration-400">
                    0{index + 1}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
